import styled from "styled-components";

export const SupportHeaderContainer = styled.div`
  width: 100%;
  padding-top: 80px;
  height: 302px;
  background: #f3f6ff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .supportContainer {
    text-align: center;
    h2 {
      font-family: Poppins;
      font-size: 36px;
      font-weight: 600;
      line-height: 0px;
      letter-spacing: 0em;
      text-align: center;
      color: #1d2646;
      @media screen and (max-width: 480px) {
        font-size: 24px;
        line-height: 28px;
      }
    }
    p {
      //styleName: Body 1 ;
      font-family: Poppins;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: center;
      color: #1d2646;
      max-width: 768px;
      padding: 0px 32px;
      @media screen and (max-width: 480px) {
        font-size: 14px;
      }
    }
  }
`;

export const SupportFormContainter = styled.div`
  max-width: 768px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 80px 16px 80px;
  box-sizing: border-box;
  .supportForm {
    width: 100%;
    padding: 16px;
    margin: auto;
  }
`;
